import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AddressBean,
  EmployeeBean,
  EmployeeSearchCriteria,
  RestEmployeeListRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputCheckbox,
  InputTextbox,
  ShowError,
  NumberFormatInputbox,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class EmployeeListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() { }
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteOnClick(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  editEmployee = (e, val, rowData) => {
    if (e.detail === 1) this.props.editEmployee(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let employee_list = this.props.employee_list;
    let employeeData = this.props.employeeData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Employee</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={employeeData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                    this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {employee_list.map((Info, index) => (
                <tr key={index}>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="td_attribute_width"
                      onClick={(e) => this.editEmployee(e, Info.code, Info)}
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {employee_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class EmployeeEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

     this.state = {
      employeeData: this.props.employeeData,
      addressData: this.props.addressData,
      // expenseSubTypeData: this.props.expenseSubTypeData,
    };
  
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };

  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = () => {
    this.props.displayAutoCompleteCityList();
  };

  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = () => {
    this.props.displayAutoCompleteStateList();
  };

  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = () => {
    this.props.displayAutoCompleteCountryCodeList();
  };

  render() {
    let employeeData = this.props.employeeData;
    employeeData.status = "A";
    let addressData = this.props.addressData;
    let isDisableFields = this.props.isDisableFields;

   
    
    
    const textAreaStyle = {
      maxHeight: "80px",
      minHeight: "9em",
      resize: "horizontal",
      padding: "5px",
      boxSizing: "border-box",
      fontSize: "15px",
      width: "350px",
    };

    return (
      <div className="MainDiv">
        <div className="employee_module">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Employee Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.codeRef}
                name="code"
                type="text"
                placeholder="Enter Code"
                onChange={this.onChange}
                value={employeeData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Employee Status</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="status"
                type="text"
                placeholder="Enter Status"
                onChange={this.onChange}
                value={employeeData.status}
                style={{ "text-transform": "capitalize" }}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Employee Name</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={employeeData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>First Name</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="firstName"
                type="text"
                placeholder="Enter First Name"
                onChange={this.onChange}
                value={employeeData.firstName}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Last Name</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="lastName"
                type="text"
                placeholder="Enter Last Name"
                onChange={this.onChange}
                value={employeeData.lastName}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>DOB</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <DatePickerComponent
                name="dateOfBirth"
                type="date"
                onChange={this.onChange}
                value={employeeData.dateOfBirth}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Commission%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={employeeData.commissionPercentage}
                onChange={this.onChange}
                className="qty_input text-right"
                decimalScale={2}
                name={"commissionPercentage"}
              // disabled={disableSalesOrderFormFields}
              // disabled={
              //   isTexco ? isDisabledFields : disableSalesOrderFormFields
              // }
              // isModifyView={isModify}
              // isMandatory={true}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <FormLabel className="professional_details">
                Professional Details
              </FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="1">
              <FormLabel>Job Title</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="jobTitle"
                type="text"
                placeholder="Enter Job Title"
                onChange={this.onChange}
                value={employeeData.jobTitle}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>SSN</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="socialSecurityNumber"
                type="text"
                placeholder="Enter SSN"
                onChange={this.onChange}
                value={employeeData.socialSecurityNumber}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>DOJ</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <DatePickerComponent
                name="dateOfJoining"
                type="date"
                onChange={this.onChange}
                value={employeeData.dateOfJoining}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Designation</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="designation"
                type="text"
                placeholder="Enter Designation"
                onChange={this.onChange}
                value={employeeData.designation}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Sales Person</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                className="employeeCheckBox"
                type="checkbox"
                name="isSalesPerson"
                onChange={this.onChange}
                checked={employeeData.isSalesPerson}
              />
            </Col>
            <Col sm="1"></Col>
            <Col sm="1">
              <FormLabel>A/C Representative</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                className="employeeCheckBox"
                type="checkbox"
                name="isAccountRepresentative"
                onChange={this.onChange}
                checked={employeeData.isAccountRepresentative}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Sales Clerk</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                className="employeeCheckBox"
                type="checkbox"
                name="isSalesClerk"
                onChange={this.onChange}
                checked={employeeData.isSalesClerk}
              />
            </Col>
            <Col sm="1"></Col>
            <Col sm="1">
              <FormLabel>UserName</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="userCode"
                type="text"
              //  placeholder="Enter User Name"
                onChange={this.onChange}
                value={employeeData.userCode}
              //  style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Password</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="password"
                type="password"
                placeholder="Enter Password"
                onChange={this.onChange}
                value={employeeData.password}
               // style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>is Portal User</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                className="employeeCheckBox"
                type="checkbox"
                name="isPortalUser"
                onChange={this.onChange}
                checked={employeeData.isPortalUser}
              />
            </Col>
            <Col sm="1"></Col>
            <Col sm="1">
              <FormLabel>is Active</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                className="employeeCheckBox"
                type="checkbox"
                name="isActive"
                onChange={this.onChange}
                checked={employeeData.isActive}
              />
            </Col>
          </Row>
        </div>
        <br />
        <div className="address_comment_module">
          <div className="address_div_employee_module">
            <Row>
              <Col sm="2">
                <FormLabel className="address">Address</FormLabel>
              </Col>
            </Row>
            <hr class="row_border"></hr>
            <Row>
              <Col sm="2">
                <FormLabel>Address 1</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="address1"
                  type="text"
                  placeholder="Enter Address"
                  onChange={this.onAddressChange}
                  value={addressData.address1}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
              <Col sm="2">
                <FormLabel>Phone 1</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="phone1"
                  type="text"
                  placeholder="Enter Phone No"
                  onChange={this.onAddressChange}
                  value={addressData.phone1}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Address 2</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="address2"
                  type="text"
                  placeholder="Enter Address"
                  onChange={this.onAddressChange}
                  value={addressData.address2}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
              <Col sm="2">
                <FormLabel>Phone 2</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="phone2"
                  type="text"
                  placeholder="Enter Phone No"
                  onChange={this.onAddressChange}
                  value={addressData.phone2}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>City</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  onChange={this.onCityChange}
                  name="city"
                  value={addressData.city}
                  lookupRequired={true}
                  lookupHandler={this.props.cityLookupHandler}
                  enterKeyEventHandler={this.cityEnterKeyEvent}
                  autoCompleteListData={
                    this.props.cityPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteCityList}
                  showAutoCompleteList={this.props.showAutoCompleteCityList}
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Mobile Phone#</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="mobilePhone"
                  type="text"
                  placeholder="Enter Mobile No"
                  onChange={this.onAddressChange}
                  value={addressData.mobilePhone}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>State</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  onChange={this.onStateChange}
                  name="state"
                  value={addressData.state}
                  lookupRequired={true}
                  lookupHandler={this.props.stateLookupHandler}
                  enterKeyEventHandler={this.stateEnterKeyEvent}
                  autoCompleteListData={
                    this.props.statePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteStateList}
                  showAutoCompleteList={this.props.showAutoCompleteStateList}
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Fax#</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="fax"
                  type="text"
                  placeholder="Enter Fax No"
                  onChange={this.onAddressChange}
                  value={addressData.fax}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Country</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  onChange={this.onCountryChange}
                  name="country"
                  value={addressData.country}
                  lookupRequired={true}
                  lookupHandler={this.props.countryLookupHandler}
                  enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.countryCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteCountryCodeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteCountryCodeList
                  }
                ></InputTextbox>
              </Col>
              <Col sm="2">
                <FormLabel>Email</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="email"
                  type="text"
                  placeholder="Enter Email id"
                  onChange={this.onAddressChange}
                  value={addressData.email}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel>Zip</FormLabel>
              </Col>
              <Col sm="3">
                {" "}
                <InputTextbox
                  name="zip"
                  type="text"
                  placeholder="Enter Zip"
                  onChange={this.onAddressChange}
                  value={addressData.zip}
                  style={{ "text-transform": "capitalize" }}
                />
              </Col>
            </Row>
          </div>
          <div className="comment_div_employee_module">
            <Row>
              <Col sm="1">
                <FormLabel className="comments">Comments</FormLabel>
              </Col>
            </Row>
            <hr class="row_border"></hr>
            <Row>
              <Col sm="2">
                {" "}
                <textarea
                  style={textAreaStyle}
                  name="comments"
                  type="text"
                  placeholder="Enter Comments"
                  onChange={this.onChange}
                  value={employeeData.comments}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

class EmployeeList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_list: [],
      response: {},
      pageTitle: "Employee",
      employeeData: new EmployeeBean(),
      pageList: new PageListBean(),
      criteria: new EmployeeSearchCriteria(),
      addressData: new AddressBean(),
      countries: [],
      cities: [],
      states: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isEmployeeListFormOpen: true,
      isEmployeeEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,

      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let employeeData = new EmployeeBean();
    employeeData.companyCode = this.companyCode;
    let addressData =  new AddressBean();
    // this.setState({ employeeData: employeeData });
   this.setState({ employeeData: employeeData ,addressData:addressData},()=>{
    this.loadAttributeCache();
    this.loadPage(1);
    this.initLookupHandlers();
    this.cleardata();
    });

  }
  loadAttributeCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.state.countries = [];
    let countries = attribute_cache.countries;
    if (!isEmptyArray(countries))
      countries.map((countryCode) => {
        this.state.countries.push(countryCode);
      });
    this.state.states = [];
    let states = attribute_cache.states;
    if (!isEmptyArray(states))
      states.map((stateCode) => {
        this.state.states.push(stateCode);
      });

    this.state.cities = [];
    let cities = attribute_cache.cities;
    if (!isEmptyArray(cities))
      cities.map((cityCode) => {
        this.state.cities.push(cityCode);
      });
  };
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  moduleCaption = "Employee";

  cleardata = () => {
    let employeeData = new EmployeeBean();
    employeeData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    // addressData.companyCode = this.companyCode;
    this.setState({
      employeeData: employeeData,
      addressData: addressData,
    });
  };
  saveEmployeeResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeEmployeeEntryForm();
  };
  saveEmployee = () => {
    let employeeData = this.state.employeeData;
    let addressData = this.state.addressData;
    employeeData.address = addressData;
    if (employeeData.isFetched == true) {
      if (SecurityAccessManager.EmployeeMaintananceEdit_IsAccessible()) {
        MasterService.updateEmployee(
          employeeData,
          this.saveEmployeeResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.EmployeeMaintananceCreate_IsAccessible()) {
        MasterService.createEmployee(
          employeeData,
          this.saveEmployeeResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editEmployeeResponse = (response) => {
  
    
    if (response.data != null) {
      if (response.data.employee != null) {
        let employee = response.data.employee;
        // let address=response.data.employee.address;
         let address=response.data.employee.address || new AddressBean();
        this.setState({
          employeeData: employee,
          addressData:address,
        },()=>{
             this.openEmployeeEntryForm();
        });
        this.disable();
      }
      else{
             this.openEmployeeEntryForm();
      }
   
    }
  };

  editEmployee = (code) => {
    let readrestInput = new EmployeeSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.employeeCode = code;
    if (SecurityAccessManager.EmployeeMaintananceView_IsAccessible()) {
      MasterService.readEmployee(
        readrestInput,
        this.editEmployeeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveEmployee();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEmployeeEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openEmployeeEntryForm = () => {
     let employeeData = this.state.employeeData;
       let addressData = this.state.addressData;


       
    this.setState({
       employeeData:employeeData,
      addressData:addressData,
      isEmployeeListFormOpen: false,
      isEmployeeEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeEmployeeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isEmployeeListFormOpen: true,
      isEmployeeEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  onChange = (e) => {
    let employeeData = this.state.employeeData;
    employeeData[e.target.name] = e.target.value;
    this.setState({ employeeData: employeeData });
  };
  onAddressChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };
  loadEmployeeResponse = (response) => {
    if (response.data != null && response.data.employeePageList != null) {
      let employees = new Array();
      if (!isEmptyArray(response.data.employeePageList.employees)) {
        employees = response.data.employeePageList.employees;
        employees.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.employeePageList.totalCount;
      pageList.currentPage = response.data.employeePageList.currentPage;
      pageList.pageSize = response.data.employeePageList.pageSize;
      this.setState({
        employee_list: employees,
        pageList: pageList,
        //  addressData: employees.address,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new EmployeeSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadEmployeePage(pageInput, criteria);
  };
  loadEmployeePage = (pageList, criteria) => {
    let requestInput = new RestEmployeeListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.EmployeeMaintananceView_IsAccessible()) {
      MasterService.getEmployeePageList(
        requestInput,
        this.loadEmployeeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  buttonCancelClickCallback = () => {
    let empArray = [];
    let errorMessage = "Access Denied";
    empArray.push(errorMessage);
    this.setState({
      alertMessage: empArray,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let employeeData = this.state.employeeData;
    this.editEmployee(employeeData.code);
  };
  deleteOnClick = (code) => {
    let criteria = new EmployeeSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.employeeCode = code;
    if (SecurityAccessManager.EmployeeMaintananceDelete_IsAccessible()) {
      MasterService.deleteEmployee(
        criteria,
        this.deleteEmployeeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteEmployeeResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;
          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };

  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }

  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };

  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.employee_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ employee_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}

        {this.state.isEmployeeListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isEmployeeListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isEmployeeListFormOpen && (
          <EmployeeListForm
            {...this.state}
            onChange={this.onChange}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            editEmployee={this.editEmployee}
            deleteOnClick={this.deleteOnClick}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isEmployeeEntryFormOpen && (
          <EmployeeEntryForm
            {...this.state}
            onChange={this.onChange}
            onAddressChange={this.onAddressChange}
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
           addressData= {this.state.addressData}
          />
        )}
      </div>
    );
  }
}

function EmployeeAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <EmployeeList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default EmployeeAttributeModule;
